const noop = (): void => undefined;

export const asyncNoop =
  (returnValue: unknown = undefined) =>
  async (): Promise<typeof returnValue> =>
    returnValue;

export default noop;
